import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { isVideo } from '../../components/helper';
import { Left, Right } from 'react-bootstrap/lib/Media';

class ViewModal extends React.Component {
  render() {
    function showTable(props) {
      return props.courseFilePathItems?.length > 0 || props.surveyLink;
    }

    return (
      <Modal {...this.props} bsSize="large">
        <Modal.Header className="modal-header-primary">
          <Modal.Title id="contained-modal-title-lg">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.props.onHide}
            >
              <i className="fa fa-close"> </i>
            </button>
            {this.props.coursename}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="form-group col-xs-4 col-md-4"
            style={{ marginLeft: '-16px' }}
          >
            <label>Start Date:</label>
            <p className="form-control-static">{this.props.startdate}</p>
          </div>
          <div className="form-group col-xs-4 col-md-4">
            <label>Course Location:</label>
            <p className="form-control-static">{this.props.courselocation}</p>
          </div>
          <div className="form-group col-xs-4 col-md-4">
            <label>Course Type:</label>
            <p className="form-control-static">{this.props.coursetype}</p>
          </div>
          <div
            className="form-group col-xs-4 col-md-4"
            style={{ marginLeft: '-16px' }}
          >
            <label>Host:</label>
            <p className="form-control-static">{this.props.host}</p>
          </div>
          <div className="form-group col-xs-4 col-md-4">
            <label>CPD Format:</label>
            <p className="form-control-static">{this.props.cpdformat}</p>
          </div>
          <div className="form-group col-xs-4 col-md-4">
            <label>Venue:</label>
            <p className="form-control-static">{this.props.venue}</p>
          </div>
          <div className="form-group">
            <label>Trainer:</label>
            <p className="form-control-static">{this.props.trainer}</p>
          </div>
          <div className="form-group">
            <label>Course Description:</label>
            <p className="form-control-static">{this.props.description}</p>
          </div>
          {this.props.howToBook && (
            <div className="form-group">
              <label>How To Book:</label>
              <p className="form-control-static">
                <a
                  href={this.props.howToBook}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  {this.props.howToBook}
                </a>
              </p>
            </div>
          )}

          {showTable(this.props) && (
            <div class="form-group">
              <div class="col-sm-10">
                <table
                  id="tblDocuments"
                  name="tblDocuments"
                  class="table table-striped table-bordered table-hover table-condensed"
                >
                  <thead>
                    <tr class="header">
                      <th>To Do</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.courseFilePathItems?.map((item) => (
                      <tr>
                        <td>{item.FileName}</td>
                        {!isVideo(item.FileName) ? (
                          <td>
                            {' '}
                            <button
                              class="btn btn-primary"
                              onClick={() =>
                                this.props.handleDownloadFile(item)
                              }
                            >
                              <span class="glyphicon glyphicon-download"></span>{' '}
                              Download
                            </button>
                          </td>
                        ) : (
                          <td style={{ width: '20%' }}>
                            <div style={{ float: 'left' }}>
                              {' '}
                              <button
                                class="btn btn-primary"
                                onClick={() =>
                                  this.props.viewFileHandle(item, '1')
                                }
                              >
                                <span class="glyphicon glyphicon-eye-open"></span>{' '}
                                View
                              </button>
                            </div>
                            <div style={{ float: 'right' }}>
                              {item.IsVideoCompleted && (
                                <span
                                  class="glyphicon glyphicon-ok"
                                  title={
                                    'Video Completed on ' +
                                    item.VideoCompletedDateStringFormat
                                  }
                                ></span>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                    {this.props.surveyLink && (
                      <tr>
                        <td>Survey</td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-primary"
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(this.props.surveyLink, '_blank', '');
                            }}
                          >
                            <span class="glyphicon glyphicon-eye-open"></span>{' '}
                            View
                          </button>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-warning" onClick={this.props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ViewModal;
